module.exports = __webpack_public_path__ + "media/styles/images/png/eraser-white-e8e243c80ef51a9d67afef328f055037.png";